module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inboxes-814cbb023dea6515db3518002f846204.svg";